import * as React from 'react'
import { createContext, useContext } from 'react'
import { Box } from '@mui/material'
import { drawer } from '../../../garvan-react/Constants/StyleConstants'
import { useGetCodeSet } from '../../../APIs/Hooks/CodeSetHooks'
import { UseQueryResult } from 'react-query'
import { tsCodeSetValue } from '../../../Typescript/API_Response'
import { AxiosResponse } from 'axios'
import { useSampleMenuItems } from '../../../DrawerMenus/MenuItems/SampleMenu'
import DrawerConfig from '../../../DrawerMenus/DrawerConfig'

interface SampleContextType {
  statusCodesQuery: UseQueryResult<tsCodeSetValue[], AxiosResponse<any, any>>
  organCodesQuery: UseQueryResult<tsCodeSetValue[], AxiosResponse<any, any>>
  storageCodesQuery: UseQueryResult<tsCodeSetValue[], AxiosResponse<any, any>>
  freezingCodesQuery: UseQueryResult<tsCodeSetValue[], AxiosResponse<any, any>>
  euthanasiaCodesQuery: UseQueryResult<
    tsCodeSetValue[],
    AxiosResponse<any, any>
  >
  descriptorCodesQuery: UseQueryResult<
    tsCodeSetValue[],
    AxiosResponse<any, any>
  >
}

const SampleContext = createContext<SampleContextType>({} as SampleContextType)
export const useSampleContext = () => useContext(SampleContext)

function SampleModule({ children }: { children: any }) {
  const statusCodesQuery = useGetCodeSet('StatusID')
  const organCodesQuery = useGetCodeSet('OrganTypeID')
  const storageCodesQuery = useGetCodeSet('StorageMediaID')
  const freezingCodesQuery = useGetCodeSet('FreezingMethodID')
  const euthanasiaCodesQuery = useGetCodeSet('MethodEuthanasiaID')
  const descriptorCodesQuery = useGetCodeSet('SampleDescriptorID')
  const menuItems = useSampleMenuItems()

  return (
    <SampleContext.Provider
      value={{
        statusCodesQuery,
        organCodesQuery,
        storageCodesQuery,
        freezingCodesQuery,
        euthanasiaCodesQuery,
        descriptorCodesQuery,
      }}
    >
      <Box
        sx={{
          width: 1,
          pl: drawer / 10,
          pr: { xl: drawer / 10 }, //center if enough space
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <DrawerConfig itemsInit={menuItems} />
        {children}
      </Box>
    </SampleContext.Provider>
  )
}

export default SampleModule
